var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"align":"center"}},[_c('div',{staticClass:"text-h6"},[_vm._v("Chat masih kosong")]),_c('div',[_vm._v("Silahkan mulai chat kepada trainer")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }